module.exports = __webpack_public_path__ + "static/media/rafiki.f5bfea0e.svg";